const SuccessModal = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3_66)">
      <rect width="64" height="64" rx="32" fill="#35BD29" />
      <rect width="64" height="64" rx="32" fill="url(#paint0_linear_3_66)" />
      <g opacity="0.4">
        <path
          d="M24.7019 8.67755C24.3355 7.31275 22.9259 6.49035 21.6043 6.99115C15.6098 9.25957 10.6843 13.6941 7.8011 19.4183C7.1643 20.6823 7.8347 22.1703 9.1547 22.6759C10.4747 23.1831 11.9419 22.5143 12.6107 21.2679C14.864 17.0586 18.5171 13.7687 22.9387 11.9671C24.2491 11.4327 25.0667 10.0439 24.7019 8.67915V8.67755Z"
          fill="#F2F6FF"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.9994 20.5714C25.6876 20.5714 20.5709 25.6882 20.5709 32C20.5709 38.3118 25.6876 43.4286 31.9994 43.4286C38.3113 43.4286 43.428 38.3118 43.428 32C43.428 25.6882 38.3113 20.5714 31.9994 20.5714ZM36.3125 29.8666C36.7122 29.3781 36.6402 28.6581 36.1517 28.2584C35.6632 27.8587 34.9432 27.9307 34.5435 28.4192L30.2003 33.7275L28.8076 32.3348C28.3613 31.8885 27.6376 31.8885 27.1913 32.3348C26.745 32.7811 26.745 33.5047 27.1913 33.951L29.477 36.2367C29.7054 36.4651 30.0196 36.5861 30.3421 36.5701C30.6646 36.554 30.9652 36.4022 31.1697 36.1523L36.3125 29.8666Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3_66"
        x1="32"
        y1="0"
        x2="32"
        y2="64"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.16" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_3_66">
        <rect width="64" height="64" rx="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SuccessModal
